<script setup lang="ts">
import { LucideHome, LucideBookmark, LucideUser, LucideBriefcase, LucideFileText } from 'lucide-vue-next'

const { t } = useI18n()
const route = useRoute()
const { hasPermission } = useUser()

const canViewB2bLeads = hasPermission('b2b.leads.viewAny') || hasPermission('b2b.leads.own') || hasPermission('b2b.leads.common')

const menuItems = computed(() => [
  {
    title: t('widget.layout_header.user_auth.panel'),
    path: '/panel',
    icon: LucideHome
  },
  {
    title: t('widget.layout_header.user_auth.favorites'),
    path: '/panel/favorites',
    icon: LucideBookmark
  },
  {
    title: t('page.b2b.leads.filter.own'),
    path: '/profile/leads',
    icon: LucideFileText
  },
  ...(canViewB2bLeads ? [{
    title: t('widget.layout_header.user_auth.b2b_leads'),
    path: '/b2b/leads',
    icon: LucideBriefcase
  }] : []),
  {
    title: t('widget.layout_header.user_auth.profile'),
    path: '/panel/profile',
    icon: LucideUser
  },
  // {
  //   title: t('widget.layout_header.user_auth.credit_lock'),
  //   path: '/panel/credit-lock',
  //   icon: LucideShieldCheck
  // }
])

const isActive = (path: string) => {
  if (path === '/panel') {
    return route.path === '/panel' || route.path.endsWith('/panel')
  }
  return route.path.startsWith(path)
}
</script>

<template>
  <aside class="hidden xl:block">
    <ContentBlock variant="white">
      <nav class="space-y-1">
        <NuxtLinkLocale
          v-for="item in menuItems"
          :key="item.path"
          :to="item.path"
          class="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors"
          :class="
            isActive(item.path)
              ? 'bg-blue-50 text-blue-600'
              : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
          "
        >
          <component :is="item.icon" class="h-5 w-5 shrink-0" />
          <span>{{ item.title }}</span>
        </NuxtLinkLocale>
      </nav>
    </ContentBlock>
  </aside>
</template>
